<template>
  <v-product-type-form-detail
    :isFormLoaded="isFormLoaded"
    :langList="langList"
    :formData="formData"
    :handleFormSubmit="handleFormSubmit"
  ></v-product-type-form-detail>
</template>

<script>
import ProductTypeFormDetail from './ProductTypeFormDetail'
import baseFormContainer from '@/mixins/baseFormContainer'

export default {
  name: 'ProductTypeFormDetailContainer',

  components: {
    'v-product-type-form-detail': ProductTypeFormDetail
  },

  data() {
    return {
      module: 'productTypeDetail',
      redirect: '/product-type'
    }
  },

  mixins: [baseFormContainer]
}
</script>
